import { useContext } from "react"
import ServerErrors from "../shared/server-errors/server-errors"
import { Step } from "../shared/multi-step/step"
import ModuleSchedule from "../shared/module-schedule/module-schedule"
import { CustomerData } from "../shared/customer-data/CustomerData"
import Payment from "../shared/payment/payment"
import CheckoutContext from "../checkout-context"
import { MultiStepHeader } from "../shared/multi-step/multi-step-header"
import { BillingData } from "../shared/customer-data/billing-data/billing-data"
import { OrderOverview } from "../shared/order-overview/order-overview"
import { StepsNavigation } from "../shared/multi-step/multi-step-navigation"
import { InvalidFormMessage } from "../shared/invalid-form-message/invalid-form-message"
import { SidebarRemarks } from "../shared/sidebar-remarks/sidebar-remarks"
import { OrderSummary } from "../shared/order-summary/order-summary"
import Consents from "../shared/order-overview/consents/consents"

export function RegularCheckout() {
  const {
    isModuleStepActive,
    isPersonalStepActive,
    isSummaryStepActive,
    consentData,
    textsMapping,
    changeConsentAgreements,
  } = useContext(CheckoutContext)

  return (
    <>
      <MultiStepHeader />

      <div className="checkout__main-area">
        <ServerErrors />

        <Step isActive={isModuleStepActive}>
          <ModuleSchedule />
        </Step>

        <Step isActive={isPersonalStepActive}>
          <CustomerData />
          <BillingData />
        </Step>

        <Step isActive={isSummaryStepActive}>
          <OrderOverview />
          <Payment />
          {Boolean(consentData.length) && (
            <Consents
              textsMapping={textsMapping}
              consents={consentData}
              changeConsentAgreements={changeConsentAgreements}
            />
          )}
        </Step>

        <div className="multi-step--desktop">
          <StepsNavigation />
          <InvalidFormMessage />
        </div>
      </div>

      <aside className="checkout__sidebar">
        <OrderSummary />
        <SidebarRemarks />
      </aside>

      <div className="multi-step--mobile">
        <StepsNavigation />
        <InvalidFormMessage />
      </div>
    </>
  )
}
